export default {
  errorCode: {
    '23000006': 'dashbord名称已存在',
    '99999999': '网络错误，请稍后再试',
    '22000056': 'group/appName/kpiKey是必填参数',
    '22000062': '数据已存在',
    '22000054': 'IT设备IP为空',
    '23000001': '应用名称为空',
    '23000002': '所属组为空',
    '23000003': '时间为空',
    '21000123': '访问地址有误',
    '23000004': '任务名称不能为空',
    '23000005': '索引名称不能为空',
    '11111111': '应用已存在',
    '20000002': '用户名称已存在',
    '21000001': '图表名称已存在',
    '00000007': '登录态失效，请重新登录',
    '00000006': '登录态失效，请重新登录',
    '23000007': '触发或恢复条件格式不正确',
    '02000001': '该用户没有当前操作的权限',
    '20000011': '用户名或密码错误',
    '22000001': '告警指标已存在',
    '22000057': '指标已存在',
    '22000002': '告警编码已存在',
    '22100001': '告警正则或值为空',
    '22100002': '告警正则与值不匹配 ',
    '22200001': '名称已存在',
    '22200002': '测试连接失败',
    '22300001': '所属分组当前为维护态',
    '22300002': '分组名冲突',
    '22300003': '应用名冲突',
    '22300010': '程序包名冲突',
    '22300011': '版本已存在',
    '22300021': '实例正在部署，不可操作',
    '22300020': '目标文件不存在',
    '22300009': '程序包不存在',
    '22300012': '程序包版本不存在',
    '22300024': '无版本信息或脚本信息',
    '22000058': '找不到kpimapping',
    '22300025': '没有可回退的版本',
    '22300026': '该版本已发布成功，不可重新发布',
    '20000012': '需要短信验证码',
    '20000013': '短信验证码错误',
    '22500001': '部门下已存在该用户',
    '20000014': '密码错误',
    '20000015': '没有超管权限',
    '22610001': '模板名已存在',
    '22400011': '指标当前配置了视图，应先删除视图',
    '240000019': '有键值key为空的数据',
    '240000020': '百分率填写错误，必须在0-100之间',
    '249999999': '操作失败，服务器异常',
    '240000001': '路由策略类型错误',
    '240000002': '失败，路由规则名为空',
    '240000003': '失败，路由策略名为空',
    '240000004': '失败，路由策略类型为空',
    '240000005': '失败，路由版本组为空',
    '240000006': '失败，版本名称为空',
    '240000007': '失败，标签名为空',
    '240000008': '失败，精准路由Key不能重复',
    '240000009': '失败，路由规则名重复',
    '240000010': '失败，版本名称重复',
    '240000011': '失败，灰度标签名重复',
    '240000012': '修改失败，路由规则Id为空',
    '240000013': '修改失败，路由版本Id为空',
    '240000014': '修改失败，tagId对应tag不存在',
    '240000015': '修改失败，routeRuleId对应routeRule不存在',
    '240000016': '修改失败，routeVersionId对应routeVersion不存在',
    '240000017': '发布失败，未找到该tag信息',
    '240000018': '操作失败，当前状态不能执行该操作',
    '230000010': '存在日志路由配置，不能被删除',
    '230000011': '开始时间需小于结束时间'
  }
}
